import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-edit',
  imports: [],
  templateUrl: './edit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './edit.component.scss',
})
export class EditComponent {
  @Input() public size = 6;
}
